import { CLEAR_SITE_DATA } from '../application';
import { RECEIVED_MODELS, RESET_MODELS, ADD_UPLOADING_ID, REMOVE_UPLOADING_ID } from './actions';

const initialState = {
  hashmap: {},
  siteLoaded: undefined,
  uploadingIds: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVED_MODELS: {
      const { models, siteId } = action;
      const updatedHashmap = {};
      for (const model of models) {
        updatedHashmap[model.id] = model;
      }

      return {
        ...state,
        hashmap: updatedHashmap,
        siteLoaded: siteId,
      };
    }
    case ADD_UPLOADING_ID: {
      return {
        ...state,
        uploadingIds: [...state.uploadingIds, action.modelId],
      };
    }
    case REMOVE_UPLOADING_ID: {
      return {
        ...state,
        uploadingIds: state.uploadingIds.filter((id) => id !== action.modelId),
      };
    }
    case RESET_MODELS:
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
